module.exports = __webpack_public_path__ + "static/media/vimeo.d568c86a.svg";